import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

import { CheckinButtonModule, MyaccountSpinnerButtonModule, SurveyButtonModule } from '@my-account/components';
import { CommonModule } from '@angular/common';
import { HmfButtonComponent, HmfTextInputComponent } from '@dsg-tech/homefield-angular';
import { NgModule } from '@angular/core';
import { OrderCardsModule } from '@my-account/order-track/components';
import { OrderTrackComponent } from './order-track.component';
import { OrderTrackRoutingModule } from './order-track-routing.module';
import { MatFormFieldModule } from '@angular/material/form-field';

@NgModule({
	imports: [
		CheckinButtonModule,
		CommonModule,
		FormsModule,
		HmfButtonComponent,
		HmfTextInputComponent,
		MatFormFieldModule,
		MyaccountSpinnerButtonModule,
		NgxMaskDirective,
		NgxMaskPipe,
		OrderCardsModule,
		OrderTrackRoutingModule,
		ReactiveFormsModule,
		SurveyButtonModule
	],
	providers: [provideNgxMask()],
	exports: [
		OrderTrackComponent
	],
	declarations: [OrderTrackComponent]
})
export class OrderTrackModule {
}
